import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Button, Result, Skeleton } from 'antd';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { canManageWorkspace } from '../utils/workspaceAccess';

const PrivateRoute = ({ children, adminOnly = false }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();
  if (loading) return <Skeleton active={false} />;
  if (!isAuthenticated)
    return (
      <Navigate
        to="/login"
        state={{ from: location.pathname + location.search }}
        replace
      />
    );
  if (adminOnly && !canManageWorkspace(user))
    return (
      <Result
        status="403"
        title="此页面仅管理员可访问"
        subTitle="如需调整权限，请联系业务对接人。"
        extra={
          <Button>
            <Link to="/app/orders">返回订单</Link>
          </Button>
        }
      />
    );
  return children;
};
export default PrivateRoute;
